
define('tmpl!core/templates/webidl-contiguous/enum.html', ['deps/handlebars'], function (hb) { return hb.compile('<span class=\'idlEnum\' id=\'{{obj.idlId}}\' data-idl data-title=\'{{obj.name}}\'>{{extAttr obj indent\n}}{{idn indent}}enum <span class=\'idlEnumID\'>{{#tryLink obj}}{{obj.name}}{{/tryLink}}</span> &#123;\n{{{children}}}{{idn indent}}&#125;;</span>');});

